module.exports = __webpack_public_path__ + "static/media/lamina14text.e35cf247.png";